<template>
  <RouterView class="Campaigns--child Loading__target p-0" />
</template>
<script>
export default {
  name: 'SocialProductsIndex',
}
</script>
